import Overview from './overview.vue';
import Full from './full.vue';
import Detail from '@rebuild/materials/shared/report/DetailIndex.vue';
import MobOverview from './mob-overview.vue';
import MobFull from './mob-full.vue';
import MobDetail from '@rebuild/materials/shared/report/MobDetail.vue';

export const componentMap = {
	overview: Overview,
	full: Full,
	detail: Detail,
	'mob-overview': MobOverview,
	'mob-full': MobFull,
	'mob-detail': MobDetail
};
